var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from "moment";
import { TV_5P_URL } from "src/utils/constant";
import { useState } from "react";
import { useCallback, useEffect } from "react";
import { captureCleverTabAnalytics } from "src/utils/analytics";
import { SOCKET_SUBSCRIPTION_METHODS } from "src/utils/constant";
import { heartBeatGreeksData, subscribeToGreeksData, } from "src/utils/greeks-web-socket";
import { SESSION_KEYS, getDataFromSession } from "src/utils/session-storage";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux";
import { onModalOpenClose, openAddToWatchlistModal, openBulkOrderPlacement, openBuySellModal, } from "../../../redux/reducers/modals";
import { getDefaultDateFormat, getFormattedNameFromString, openChartTab, } from "../../../utils/methods";
import { heartBeatData, subscribeToData, unsubscribeDataByScrip, } from "../../../utils/websocketwrapper";
import { getScripCodeFromExpiry } from "src/pages/fno-stats/fno-stats-commonmethods";
const useDataHook = (props) => {
    const dispatch = useAppDispatch();
    const openFeedWsHeartBeat = useAppSelector((state) => state.openFeedWs.heartBeat);
    const [isOcIframe, setisOcIframe] = useState(() => window.location.pathname.includes("oc-iframe"));
    const { symbol, expiry, putName, putExch, putExchType, putScripCode, putLTP, prevPutClose, callExch, callExchType, callLTP, callName, callScripCode, prevCallClose, inView, observerRef, onVisibilityChange, strike, lotSize, selectedOptionType, subscribeDepthData, componentName, } = props;
    const onAddToBasketPut = (openedFrom, isBuy) => __awaiter(void 0, void 0, void 0, function* () {
        const type = "PE";
        const payload1 = yield getScripCodeFromExpiry(symbol, expiry, putExchType, type, strike);
        const payload = {
            isBuy: true,
            orderFor: "P",
            orderData: undefined,
            netPositionDetail: undefined,
            vttOrderDetail: undefined,
            name: payload1
                ? getFormattedNameFromString(payload1.name)
                : getFormattedNameFromString(putName),
            exchange: payload1 ? payload1.exchange : putExch,
            exchangeType: payload1 ? payload1.exchangeType : putExchType,
            scripCode: payload1 ? payload1.scripCode : putScripCode,
            lastTradePrice: putLTP,
            previousClose: prevPutClose,
            isBasket: true,
            openedFrom: openedFrom,
            lotSize: lotSize,
        };
        captureCleverTabAnalytics("Basket_Click", {
            Action: "Basket_Icon",
            Initiation_Screen: openedFrom,
        });
        dispatch(openBuySellModal(payload));
    });
    const onAddToWatchlistPut = (openedFrom) => {
        const payload = {
            Exch: putExch,
            ExchType: putExchType,
            ScripCode: putScripCode,
            name: putName,
        };
        dispatch(openAddToWatchlistModal(payload));
        dispatch(onModalOpenClose({ componentName: "watchlistModal", currState: "open" }));
        captureCleverTabAnalytics("Add to Watchlist put Opened - FNO", {
            StockName: payload.name,
            ExchangeType: payload.ExchType,
            ScripCode: payload.ScripCode.toString(),
            componentName: openedFrom,
        });
    };
    const onAddToWatchlistCall = (openedFrom) => {
        const payload = {
            Exch: callExch,
            ExchType: callExchType,
            ScripCode: callScripCode,
            name: callName,
        };
        captureCleverTabAnalytics("Add to Watchlist call Opened - FNO", {
            StockName: payload.name,
            ExchangeType: payload.ExchType,
            ScripCode: payload.ScripCode.toString(),
            componentName: openedFrom,
        });
        dispatch(openAddToWatchlistModal(payload));
        dispatch(onModalOpenClose({ componentName: "watchlistModal", currState: "open" }));
    };
    const onBuySellActionPut = (openedFrom, isBuy) => __awaiter(void 0, void 0, void 0, function* () {
        const type = "PE";
        const payload1 = yield getScripCodeFromExpiry(symbol, expiry, putExchType, type, strike);
        const payload = {
            isBuy: isBuy || false,
            orderFor: "P",
            orderData: undefined,
            netPositionDetail: undefined,
            vttOrderDetail: undefined,
            name: payload1
                ? getFormattedNameFromString(payload1.name)
                : getFormattedNameFromString(putName),
            exchange: payload1 ? payload1.exchange : putExch,
            exchangeType: payload1 ? payload1.exchangeType : putExchType,
            scripCode: payload1 ? payload1.scripCode : putScripCode,
            lastTradePrice: putLTP,
            previousClose: prevPutClose,
            openedFrom: openedFrom,
            lotSize: lotSize,
        };
        captureCleverTabAnalytics(`Buy/Sell Action Put Opened - FNO`, {
            StockName: payload.name,
            ExchangeType: payload.exchangeType,
            ScripCode: payload.scripCode.toString(),
            componentName: openedFrom,
        });
        if (isOcIframe) {
            // console.log("Post messsage hit from option chain iframe on Put", payload);
            window.parent.postMessage({ actionType: "buysellform", data: payload }, `${TV_5P_URL}`);
        }
        else {
            dispatch(openBuySellModal(payload));
        }
    });
    const onBuySellActionCall = (component, isBuy) => __awaiter(void 0, void 0, void 0, function* () {
        //let expiry_date = moment(expiry).format("DD MMM YYYY").toUpperCase();
        //const symbol1 = symbol + " " + expiry_date + " CE " + strike;
        const type = "CE";
        const payload1 = yield getScripCodeFromExpiry(symbol, expiry, callExchType, type, strike);
        const payload = {
            isBuy: isBuy || false,
            orderFor: "P",
            orderData: undefined,
            netPositionDetail: undefined,
            vttOrderDetail: undefined,
            name: payload1
                ? getFormattedNameFromString(payload1.name)
                : getFormattedNameFromString(callName),
            exchange: payload1 ? payload1.exchange : callExch,
            exchangeType: payload1 ? payload1.exchangeType : callExchType,
            scripCode: payload1 ? payload1.scripCode : callScripCode,
            lastTradePrice: callLTP,
            previousClose: prevCallClose,
            openedFrom: component,
            lotSize: lotSize,
        };
        captureCleverTabAnalytics(`Buy/Sell Action Call Opened - FNO`, {
            StockName: payload.name,
            ExchangeType: payload.exchangeType,
            ScripCode: payload.scripCode.toString(),
            componentName: component,
        });
        if (isOcIframe) {
            // console.log(
            //   "Post messsage hit from option chain iframe on Call",
            //   payload
            // );
            window.parent.postMessage({ actionType: "buysellform", data: payload }, `${TV_5P_URL}`);
        }
        else {
            dispatch(openBuySellModal(payload));
        }
    });
    const onChartIconClick = (scripSubType, //CE,PE
    openedFrom) => {
        // getScripType(singleData.fullName, singleData.exchange, singleData.exchType);
        const fullName = symbol +
            " " +
            moment(expiry).format("DD MMM YYYY") +
            " " +
            scripSubType +
            " " +
            strike;
        const chartData = {
            fullName: fullName,
            strikePrice: strike ? Number(strike) : 0,
            exchange: putExch,
            exchangeType: putExchType,
            expiry: moment(expiry).format("DD MMM YY"),
            symbol: symbol ? symbol : "",
            scripCode: scripSubType == "CE" ? callScripCode : putScripCode,
            chartEvent: true,
        };
        captureCleverTabAnalytics("Screen_Open", {
            Action: "Charts",
            Initiation_Screen: openedFrom,
        });
        if (isOcIframe) {
            // console.log(
            //   "Post messsage hit from option chain iframe to open chart",
            //   chartData
            // );
            window.parent.postMessage({ actionType: "chartNavigation", data: chartData }, `${TV_5P_URL}`);
        }
        else {
            openChartTab(chartData);
        }
    };
    const onAddToBasketCall = (openedFrom) => __awaiter(void 0, void 0, void 0, function* () {
        const type = "CE";
        const payload1 = yield getScripCodeFromExpiry(symbol, expiry, callExchType, type, strike);
        const payload = {
            isBuy: true,
            orderFor: "P",
            orderData: undefined,
            netPositionDetail: undefined,
            vttOrderDetail: undefined,
            name: payload1
                ? getFormattedNameFromString(payload1.name)
                : getFormattedNameFromString(callName),
            exchange: payload1 ? payload1.exchange : callExch,
            exchangeType: payload1 ? payload1.exchangeType : callExchType,
            scripCode: payload1 ? payload1.scripCode : callScripCode,
            lastTradePrice: callLTP,
            previousClose: prevCallClose,
            isBasket: true,
            openedFrom: openedFrom,
            lotSize: lotSize,
        };
        captureCleverTabAnalytics("Basket_Click", {
            Action: "Basket_Icon",
            Initiation_Screen: openedFrom,
        });
        dispatch(openBuySellModal(payload));
    });
    const sendWsMessage = useCallback((heartBeatMessage, operation, tokensInfo) => {
        if (tokensInfo.length == 0) {
            return;
        }
        const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
        const method1 = {
            Method: "GetScripInfoForFuture",
            Operation: operation,
            ClientCode: clientCode,
            MarketFeedData: tokensInfo,
        };
        const method2 = {
            Method: "MarketFeedV3",
            Operation: operation,
            ClientCode: clientCode,
            MarketFeedData: tokensInfo,
        };
        if (selectedOptionType == "Greeks") {
            const method3 = {
                Method: SOCKET_SUBSCRIPTION_METHODS.NEW_BASE_GREEKS,
                Operation: operation,
                ClientCode: clientCode,
                MarketFeedData: tokensInfo,
            };
            if (heartBeatMessage) {
                heartBeatGreeksData(method3, componentName, () => { });
            }
            else {
                subscribeToGreeksData(method3, componentName, () => { });
            }
        }
        // if (subscribeDepthData != undefined && subscribeDepthData) {
        //   const method3 = {
        //     Method: "MarketDepthService",
        //     Operation: operation,
        //     ClientCode: clientCode,
        //     MarketFeedData: tokensInfo,
        //   };
        //   if (heartBeatMessage) {
        //     heartBeatData(method3, componentName, () => {});
        //   } else {
        //     subscribeToData(method3, componentName, () => {});
        //   }
        // }
        if (heartBeatMessage) {
            heartBeatData(method1, componentName, () => { });
            heartBeatData(method2, componentName, () => { });
        }
        else {
            subscribeToData(method1, componentName, () => { });
            subscribeToData(method2, componentName, () => { });
        }
    }, [componentName, selectedOptionType, subscribeDepthData]);
    const onBulkOrderPlacement = (isBuy, openedFrom) => {
        const expiry_date = getDefaultDateFormat(moment(expiry).format("DD MMM YYYY").toUpperCase());
        const payload = [
            {
                isBuy: isBuy || false,
                strike: strike,
                ScripCode: callScripCode,
                Exchange: callExch,
                ExchangeType: callExchType,
                DisQty: 0,
                AtMarket: false,
                IsIntraday: false,
                LastTradePrice: callLTP,
                Name: getFormattedNameFromString(symbol + " " + expiry_date + " " + "CE" + " " + strike),
                prevClose: prevCallClose,
                Price: callLTP + "",
                lotSize: lotSize,
                Qty: lotSize,
                StopLossPrice: null,
                IsStopLossOrder: false,
                openedFrom,
            },
            {
                isBuy: isBuy || false,
                strike: strike,
                ScripCode: putScripCode,
                Exchange: putExch,
                ExchangeType: putExchType,
                DisQty: 0,
                AtMarket: false,
                IsIntraday: false,
                LastTradePrice: putLTP,
                Name: getFormattedNameFromString(symbol + " " + expiry_date + " " + "PE" + " " + strike),
                prevClose: prevPutClose,
                Price: putLTP + "",
                lotSize: lotSize,
                Qty: lotSize,
                StopLossPrice: null,
                IsStopLossOrder: false,
                openedFrom,
            },
        ];
        dispatch(openBulkOrderPlacement(payload));
        //Abhirup
        captureCleverTabAnalytics("Bulk Order - Buy/Sell form opened", {
            payload: payload,
            componentName: openedFrom,
        });
    };
    useEffect(() => {
        const data = [];
        if (callScripCode > 0) {
            data.push({
                Exch: callExch,
                ExchType: callExchType,
                ScripCode: callScripCode,
            });
        }
        if (putScripCode > 0) {
            data.push({
                Exch: putExch,
                ExchType: putExchType,
                ScripCode: putScripCode,
            });
        }
        if (inView && data.length > 0) {
            sendWsMessage(openFeedWsHeartBeat, "Subscribe", data);
        }
        else {
            if (callScripCode > 0) {
                unsubscribeDataByScrip(componentName, {
                    Exch: callExch,
                    ExchType: callExchType,
                    ScripCode: callScripCode,
                });
            }
            if (putScripCode > 0) {
                unsubscribeDataByScrip(componentName, {
                    Exch: putExch,
                    ExchType: putExchType,
                    ScripCode: putScripCode,
                });
            }
        }
    }, [
        callExch,
        callExchType,
        callScripCode,
        inView,
        openFeedWsHeartBeat,
        componentName,
        putExch,
        putExchType,
        putScripCode,
        selectedOptionType,
    ]);
    return {
        onAddToBasketPut,
        onAddToWatchlistPut,
        onBuySellActionPut,
        onBuySellActionCall,
        onChartIconClick,
        onAddToBasketCall,
        onAddToWatchlistCall,
        sendWsMessage,
        onBulkOrderPlacement,
    };
};
export default useDataHook;
